// extracted by mini-css-extract-plugin
module.exports = {"mail-sent":"_4f5068","mail-sent__title":"_31e191","mail-sent__text":"a418a2","mail-sent__sub-text":"_406838","mail-sent__sub-text-mail":"_981246","mail-sent__icon":"_0b56f5"};